import { StorefrontModule } from '@vue-storefront/core/lib/modules';

export const InstantCheckoutModule: StorefrontModule = function () {}
